import { IAssociatedAddress } from './IAssociatedAddress';
import { IOrderLinkRequest } from '../../../../state';
import { eClientIntent } from '../../../../ui-toolkit/enums/eClientIntent';
import { eOrderLinkType } from '../../../../ui-toolkit/enums/eOrderLinkType';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';

export interface ICreateOrderLinkRequestProps {
  associatedAddress: IAssociatedAddress;
  id: string;
  transactionCategory: eTransactionCategory;
}
const createOrderLinkRequest = ({
  associatedAddress,
  id,
  transactionCategory,
}: ICreateOrderLinkRequestProps): IOrderLinkRequest =>
  transactionCategory === eTransactionCategory.Purchase
    ? associatedAddress.transactionCategory === eTransactionCategory.Purchase
      ? {
          type: eOrderLinkType.acquisition_resale,
          items: [
            {
              id,
              type: eClientIntent.resale,
            },
            {
              id: associatedAddress.id,
              type: eClientIntent.acquisition,
            },
          ],
        }
      : {
          type: eOrderLinkType.search_acquisition,
          items: [
            {
              id,
              type: eClientIntent.purchase,
            },
            {
              id: associatedAddress.id,
              type: eClientIntent.certification,
            },
          ],
        }
    : {
        type: eOrderLinkType.search_acquisition,
        items: [
          {
            id,
            type: eClientIntent.certification,
          },
          {
            id: associatedAddress.id,
            type: eClientIntent.purchase,
          },
        ],
      };

export default createOrderLinkRequest;
